import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogContent, MatDialogRef } from '@angular/material/dialog';
import { MatProgressSpinner } from '@angular/material/progress-spinner';

import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { ExcelBulkSiteUploadLogicService } from '../../../services/logic-services';

@Component({
    selector: 'kh-loader-dialog',
    templateUrl: './loader-dialog.component.html',
    styleUrls: ['./loader-dialog.component.scss'],
    imports: [
        MatProgressSpinner,
        MatDialogContent,
    ]
})
export class LoaderDialogComponent implements OnInit, OnDestroy {
    private _destroy$ = new Subject<void>();

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: string,
        private _excelBulkSiteUploadLogicService: ExcelBulkSiteUploadLogicService,
        private _dialogRef: MatDialogRef<LoaderDialogComponent>,
    ) { }

    ngOnDestroy(): void {
        this._destroy$.next();
        this._destroy$.complete();
    }

    ngOnInit(): void {
        this._excelBulkSiteUploadLogicService.startTimer$
            .pipe(takeUntil(this._destroy$))
            .subscribe((result: boolean) => {
                if (!result) {
                    this._dialogRef.close();
                }
            });
    }
}
